import type { PostHogConfig } from 'posthog-js';

/**
 * Analytics keeps its identity in memory only. Who is signed in comes from the server on every load,
 * so nothing about the person — id, name, email — is left in this browser's storage or cookies.
 */
export const POSTHOG_OPTIONS = {
  api_host: import.meta.env.VITE_POSTHOG_ENDPOINT,
  persistence: 'memory',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  // Also keeps web vitals off: this SDK reads them from capture_performance, not an option of their own.
  capture_performance: false,
} as const satisfies Partial<PostHogConfig>;
